import { Component, OnInit } from '@angular/core';
import { UiService } from '../../../services/core.ui.service';
import { GfTitleService } from '../../../services/core.title.service';
import { AdminService } from '../../../services/core.admin.service';

@Component({
    selector: 'adminCronjobsView',
    template: require('./admin.cronjobs.component.html')
})

export class SiteAdminCronjobsComponent implements OnInit {
    protected options = {
        'Off' : 0,
        'On' : 2
    }
    protected cronjobs;
    protected cronjobsLoaded = false;
    protected saving = false;

    constructor(
        private $window: Window,
        private uiService: UiService,
        private adminService: AdminService,
        private titleService: GfTitleService,
    ) { }

    ngOnInit() {
        this.titleService.setTitle('Site Admin', 'Cronjobs');
        this.adminService.getCronjobs()
            .then(
            (results) => {
                this.cronjobs = Object.keys(results).map(key => results[key]);
                this.cronjobsLoaded = true;
            })
            .catch((error => { console.log("Error fetching cronjobs: ", error);}))
    }

    setCronjob(value, cronjob) {
        cronjob.configStatus = value;
    }

    save = () => {
        this.saving = true;
        this.adminService.putCronjobs({ cronjobs: this.cronjobs })
            .then(() => {
                this.uiService.message.showSuccess("Cronjob configuration was saved successfully", "Cronjob Configuration");
                this.saving = false;
            }, (response) => {
                console.log(response);
                this.uiService.message.showError("Sorry, could not save cronjob configuration", "Cronjob Configuration");
                this.saving = false;
            });
    }
}
